import React from 'react';
import { Link } from 'react-router-dom';
import { Carousel } from 'react-bootstrap';

export default class Menu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLogDetails: false,
        };
    }

    render() {
        return (
            <div className="pages">
                <div data-page="tables" className="page no-toolbar no-navbar">
                    <div className="page-content">
                        <div className="navbarpages navbarpagesbg">
                            <div class="navbar_left">
                                <h2 style={{ 'margin-top': '10px' }} ><b style={{ 'padding-left': '100px' }}>वाहतुकदार</b></h2>
                            </div>
                        </div>
                        <div id="pages_maincontent" style={{ padding: '0px 0px 0px 0px', overflow: 'scroll' }}>
                            <Carousel>
                                < Carousel.Item >
                                    <img src="images/transporter.png" alt="" title="" style={{ width: 500, height: 630 }} />
                                </Carousel.Item>
                                < Carousel.Item >
                                    <img src="images/canetransport.png" alt="" title="" style={{ width: 500, height: 630 }} />
                                </Carousel.Item>
                            </Carousel>
                        </div>
                        <div class="swiper-container-toolbar swiper-toolbar swiper-init" data-effect="slide" data-slides-per-view="1" data-slides-per-group="1" data-space-between="0" data-pagination=".swiper-pagination-toolbar">
                            <div class="swiper-pagination-toolbar"></div>
                            <div class="swiper-wrapper">
                                <div class="swiper-slide toolbar-icon">
                                    <div>
                                        <Link to='/Login' className="external" style={{ 'background-color': '#9CE2FF', 'margin-left': '120px' }}><img src="images/icons/blue/lock.png" alt="" title="" />LOGIN</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/component/Menu.jsx